module.exports = __webpack_public_path__ + "static/img/home-avatar.90d0f16.png";


//////////////////
// WEBPACK FOOTER
// ./src/newpage/static/images/home-avatar.png
// module id = VXtY
// module chunks = 1